export enum BiblesMutationTypes{
    ADD_BIBLE = 'ADD_BIBLE',
    REMOVE_BIBLE_PENDING = 'REMOVE_BIBLE_PENDING',
    SET_BIBLE_PROGRESS = 'SET_BIBLE_PROGRESS',
    SET_BIBLES = 'SET_BIBLES',
    SET_BIBLES_ERROR = 'SET_BIBLES_ERROR',
    SET_BIBLES_PENDING = 'SET_BIBLES_PENDING',
    SET_BIBLE_ERROR = 'SET_BIBLE_ERROR',
    SET_BIBLE_PENDING = 'SET_BIBLE_PENDING',
    SET_EXPORT_BIBLE_TO_IMANAGE_ERROR = 'SET_EXPORT_BIBLE_TO_IMANAGE_ERROR',
    SET_EXPORT_BIBLE_TO_IMANAGE_PENDING = 'SET_EXPORT_BIBLE_TO_IMANAGE_PENDING',
    SET_POST_BIBLE_PENDING = 'SET_POST_BIBLE_PENDING',
}
